import dynamic from 'next/dynamic';

import { useDevice } from '@contexts/device';

const MobileClearAllFilters = dynamic(() => import('./MobileClearAllFilters'));
const DesktopClearAllFilters = dynamic(
  () => import('./DesktopClearAllFilters')
);

interface Props {
  text?: string;
  onClick: () => void;
  disabled?: boolean;
}

const ClearAllFilters = ({
  text = 'Tüm Filtreleri Temizle',
  onClick,
  disabled,
}: Props) => {
  const { isDesktop } = useDevice();

  return isDesktop ? (
    <DesktopClearAllFilters text={text} onClick={onClick} disabled={disabled} />
  ) : (
    <MobileClearAllFilters text={text} onClick={onClick} disabled={disabled} />
  );
};

export default ClearAllFilters;
